/* ==========================================================================
   z500-project.js - Client Logic: Slider 3D, Zoom Lightbox, Dinamica Completa
   ========================================================================== */
  // CACHE & PRELOAD IMAGINI 3D PENTRU TRANZITIE INSTANTANEE FARA LAG
  function zPreloadImages(list) {
    if (!list || !list.length) return;
    if (!window.zPreloadCacheMap) window.zPreloadCacheMap = {};
    list.forEach(function(url) {
      if (url && !window.zPreloadCacheMap[url]) {
        var img = new Image();
        img.src = url;
        if (typeof img.decode === 'function') {
          img.decode().catch(function() {});
        }
        window.zPreloadCacheMap[url] = img;
      }
    });
  }

  function zSelectSlide(idx) {
    if (!zImagesList || zImagesList.length === 0) return;
    zPreloadImages(zImagesList);
    zCurrentIndex = (idx + zImagesList.length) % zImagesList.length;

    var mainImg = document.getElementById("zHeroMain");
    if (mainImg) mainImg.src = zImagesList[zCurrentIndex];

    var side1 = document.getElementById("zHeroSide1");
    var side2 = document.getElementById("zHeroSide2");
    var nextIdx1 = (zCurrentIndex + 1) % zImagesList.length;
    var nextIdx2 = (zCurrentIndex + 2) % zImagesList.length;

    if (side1 && zImagesList.length > 1) {
      side1.src = zImagesList[nextIdx1];
    }
    if (side2 && zImagesList.length > 2) {
      side2.src = zImagesList[nextIdx2];
    }

    var sideSlide1 = document.getElementById("zSideSlide1");
    var sideSlide2 = document.getElementById("zSideSlide2");
    if (sideSlide1) {
      sideSlide1.onclick = function() { zSelectSlide(nextIdx1); zOpenLbox(nextIdx1); };
    }
    if (sideSlide2) {
      sideSlide2.onclick = function() { zSelectSlide(nextIdx2); zOpenLbox(nextIdx2); };
    }

    var thumbs = document.querySelectorAll("#zThumbTrack .z-thumb-item");
    thumbs.forEach(function(el, i) {
      if (i === zCurrentIndex) {
        el.classList.add("active");
        el.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      } else {
        el.classList.remove("active");
      }
    });
  }

  if (typeof window !== 'undefined' && window.zImagesList) {
    zPreloadImages(window.zImagesList);
  }

  function zStepImg(dir) {
    zSelectSlide(zCurrentIndex + dir);
  }

  // LIGHTBOX LOGIC - SUPORT COMPLET PENTRU GALERII MULTIPLE & NAVIGARE STANGA/DREAPTA
  var zLboxActiveUrls = [];
  var zLboxCaptions = [];
  var zLboxCurIdx = 0;

  function zOpenLboxGallery(urls, captions, startIndex) {
    if (!urls || urls.length === 0) return;
    zLboxActiveUrls = urls;
    zLboxCaptions = captions || [];
    zLboxCurIdx = ((startIndex || 0) + zLboxActiveUrls.length) % zLboxActiveUrls.length;
    var cap = (zLboxCaptions && zLboxCaptions[zLboxCurIdx]) 
      ? zLboxCaptions[zLboxCurIdx] 
      : ("Imagine " + (zLboxCurIdx + 1) + " din " + zLboxActiveUrls.length);
    zShowLbox(zLboxActiveUrls[zLboxCurIdx], cap);
  }

  function zOpenLbox(idx) {
    var list = (window.zImagesFullList && window.zImagesFullList.length > 0) ? window.zImagesFullList : window.zImagesList;
    if (!list || list.length === 0) return;
    var heroCaps = list.map(function(u, i) {
      return "Randare 3D Exterior " + (i + 1) + " din " + list.length;
    });
    zOpenLboxGallery(list, heroCaps, idx);
  }

  // ZOOM & PAN STATE
  var zZoomScale = 1;
  var zPanX = 0;
  var zPanY = 0;
  var zIsDragging = false;
  var zDragStartX = 0;
  var zDragStartY = 0;

  function zApplyTransform() {
    var stage = document.getElementById("zLboxStage");
    if (!stage) return;
    stage.style.transform = "translate(" + zPanX + "px, " + zPanY + "px) scale(" + zZoomScale + ")";
  }

  function zAdjustZoom(delta, originX, originY) {
    var newScale = Math.min(Math.max(1, zZoomScale + delta), 4.5);
    if (newScale === zZoomScale) return;
    if (newScale === 1) {
      zPanX = 0;
      zPanY = 0;
    }
    zZoomScale = newScale;
    zApplyTransform();
  }

  function zResetZoom() {
    zZoomScale = 1;
    zPanX = 0;
    zPanY = 0;
    zApplyTransform();
  }

  function zOpenLboxUrl(url, caption) {
    if (!url) return;
    zOpenLboxGallery([url], [caption || ""], 0);
  }

  function zShowLbox(url, cap) {
    var modal = document.getElementById("zLightboxModal");
    var img = document.getElementById("zLboxImg");
    var caption = document.getElementById("zLboxCaption");
    var prevBtn = document.querySelector(".z-lbox-prev");
    var nextBtn = document.querySelector(".z-lbox-next");
    if (!modal || !img) return;

    zResetZoom();
    img.src = url;
    if (caption) caption.textContent = cap || "";

    var hasMultiple = zLboxActiveUrls && zLboxActiveUrls.length > 1;
    if (prevBtn) prevBtn.style.display = hasMultiple ? "flex" : "none";
    if (nextBtn) nextBtn.style.display = hasMultiple ? "flex" : "none";

    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    document.documentElement.classList.add("z-lightbox-open");

    modal.style.display = "flex";
    document.body.style.overflow = "hidden";
  }

  function zStepLbox(dir) {
    if (!zLboxActiveUrls || zLboxActiveUrls.length <= 1) return;
    zLboxCurIdx = (zLboxCurIdx + dir + zLboxActiveUrls.length) % zLboxActiveUrls.length;
    var cap = (zLboxCaptions && zLboxCaptions[zLboxCurIdx]) 
      ? zLboxCaptions[zLboxCurIdx] 
      : ("Imagine " + (zLboxCurIdx + 1) + " din " + zLboxActiveUrls.length);
    zShowLbox(zLboxActiveUrls[zLboxCurIdx], cap);
  }

  function zCloseDirect(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    var modal = document.getElementById("zLightboxModal");
    if (modal) {
      modal.style.display = "none";
    }
    document.documentElement.classList.remove("z-lightbox-open");
    document.body.style.overflow = "";
    zResetZoom();
  }

  function zCloseLightbox(e) {
    if (e && e.target) {
      // Daca a dat click pe body-ul de zoom sau butoane, nu inchide
      if (e.target.closest && (e.target.closest(".z-lightbox-body") || e.target.closest(".z-lightbox-controls") || e.target.closest(".z-lightbox-arrow"))) {
        return;
      }
    }
    zCloseDirect(e);
  }

  window.zCloseDirect = zCloseDirect;
  window.zCloseLightbox = zCloseLightbox;
  window.zResetZoom = zResetZoom;
  window.zAdjustZoom = zAdjustZoom;

  document.addEventListener("keydown", function(e) {
    var modal = document.getElementById("zLightboxModal");
    if (modal && modal.style.display === "flex") {
      if (e.key === "Escape") zCloseLightbox();
      if (e.key === "ArrowLeft") zStepLbox(-1);
      if (e.key === "ArrowRight") zStepLbox(1);
      if (e.key === "+" || e.key === "=") zAdjustZoom(0.35);
      if (e.key === "-" || e.key === "_") zAdjustZoom(-0.35);
      if (e.key === "0") zResetZoom();
    }
  });

  // INITIALIZARE DRAG & PAN & SCROLL ZOOM PE LIGHTBOX BODY
  (function initLboxPanZoom() {
    function setupEvents() {
      var body = document.querySelector(".z-lightbox-body");
      if (!body) return;

      // Double-click toggle (100% <-> 220%)
      body.addEventListener("dblclick", function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (zZoomScale > 1.2) {
          zResetZoom();
        } else {
          zZoomScale = 2.2;
          zPanX = 0;
          zPanY = 0;
          zApplyTransform();
        }
      });

      // Wheel / pinch zoom
      body.addEventListener("wheel", function(e) {
        e.preventDefault();
        var delta = (e.deltaY < 0) ? 0.3 : -0.3;
        zAdjustZoom(delta);
      }, { passive: false });

      // Drag to Pan
      body.addEventListener("mousedown", function(e) {
        if (e.button !== 0) return;
        zIsDragging = true;
        zDragStartX = e.clientX - zPanX;
        zDragStartY = e.clientY - zPanY;
        body.classList.add("is-dragging");
      });

      window.addEventListener("mousemove", function(e) {
        if (!zIsDragging) return;
        zPanX = e.clientX - zDragStartX;
        zPanY = e.clientY - zDragStartY;
        zApplyTransform();
      });

      window.addEventListener("mouseup", function() {
        if (zIsDragging) {
          zIsDragging = false;
          body.classList.remove("is-dragging");
        }
      });

      // Touch events support for mobile / tablets
      var touchStartDist = 0;
      var lastTouchX = 0;
      var lastTouchY = 0;

      body.addEventListener("touchstart", function(e) {
        if (e.touches.length === 1) {
          lastTouchX = e.touches[0].clientX - zPanX;
          lastTouchY = e.touches[0].clientY - zPanY;
          zIsDragging = true;
        } else if (e.touches.length === 2) {
          zIsDragging = false;
          touchStartDist = Math.hypot(
            e.touches[0].clientX - e.touches[1].clientX,
            e.touches[0].clientY - e.touches[1].clientY
          );
        }
      }, { passive: true });

      body.addEventListener("touchmove", function(e) {
        if (zIsDragging && e.touches.length === 1) {
          zPanX = e.touches[0].clientX - lastTouchX;
          zPanY = e.touches[0].clientY - lastTouchY;
          zApplyTransform();
        } else if (e.touches.length === 2) {
          var dist = Math.hypot(
            e.touches[0].clientX - e.touches[1].clientX,
            e.touches[0].clientY - e.touches[1].clientY
          );
          var factor = dist / (touchStartDist || dist);
          zZoomScale = Math.min(Math.max(1, zZoomScale * factor), 4.5);
          touchStartDist = dist;
          zApplyTransform();
        }
      }, { passive: true });

      body.addEventListener("touchend", function() {
        zIsDragging = false;
      });
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", setupEvents);
    } else {
      setupEvents();
    }
  })();

  // RENDER DYNAMIC CONTENT DIN DATE STRUCTURATE (METAFIELDS + DATA ISLAND)
  (function() {
    function initZ500Dynamic() {
      var metaEl = document.getElementById("z500-metafields-data");
      var legacyDataEl = document.getElementById("z500-project-data");
      var dynContainer = document.getElementById("z500-dynamic-content");

    var pData = window.z500RawData || null;

    // 1. Citire din insula de date JSON (garantata 100% de importul CSV nativ Shopify)
    if (!pData && legacyDataEl) {
      try {
        pData = JSON.parse(legacyDataEl.textContent);
      } catch(e) {
        pData = null;
      }
    }

    // 2. Daca exista Metafields native Shopify, le unim pentru filtrare si afisare
    if (metaEl) {
      try {
        var mObj = JSON.parse(metaEl.textContent);
        if (mObj) {
          if (!pData) {
            pData = { specs: {}, storeys: [], placement: {}, elevations: [], interiors: [] };
          }
          if (mObj.specs) {
            for (var k in mObj.specs) {
              if (mObj.specs[k] && parseFloat(mObj.specs[k]) > 0) {
                pData.specs[k] = mObj.specs[k];
              }
            }
          }
          if (mObj.plot_dimensions) {
            var plotDims = typeof mObj.plot_dimensions === "string" ? JSON.parse(mObj.plot_dimensions) : mObj.plot_dimensions;
            if (plotDims && typeof plotDims === "object") {
              pData.specs = pData.specs || {};
              pData.placement = pData.placement || {};
              if (plotDims.lot_width && (!pData.specs.lot_width || parseFloat(pData.specs.lot_width) === 0)) {
                pData.specs.lot_width = parseFloat(plotDims.lot_width);
                pData.placement.lot_width = parseFloat(plotDims.lot_width);
              }
              if (plotDims.lot_length && (!pData.specs.lot_length || parseFloat(pData.specs.lot_length) === 0)) {
                pData.specs.lot_length = parseFloat(plotDims.lot_length);
                pData.placement.lot_length = parseFloat(plotDims.lot_length);
              }
              if (plotDims.facade_width && (!pData.specs.elevation_width || parseFloat(pData.specs.elevation_width) === 0)) {
                pData.specs.elevation_width = parseFloat(plotDims.facade_width);
                pData.placement.elevation_width = parseFloat(plotDims.facade_width);
              }
              if (plotDims.footprint && (!pData.specs.footprint_area || parseFloat(pData.specs.footprint_area) === 0)) {
                pData.specs.footprint_area = parseFloat(plotDims.footprint);
                pData.placement.footprint = parseFloat(plotDims.footprint);
              }
            }
          }
          if (mObj.compartimentare) {
            var compObj = typeof mObj.compartimentare === "string" ? JSON.parse(mObj.compartimentare) : mObj.compartimentare;
            if (compObj) {
              if (compObj.views && compObj.views.length > 0) pData.views = compObj.views;
              if (compObj.storeys && compObj.storeys.length > 0) pData.storeys = compObj.storeys;
              if (compObj.placement_image) pData.placement_image = compObj.placement_image;
              if (compObj.placement && (compObj.placement.url || compObj.placement.cdn_url)) pData.placement = compObj.placement;
              if (compObj.elevations && compObj.elevations.length > 0) pData.elevations = compObj.elevations;
              if (compObj.interiors && compObj.interiors.length > 0) pData.interiors = compObj.interiors;

              // Citire dimensiuni si lungimi direct din JSON (root, placement sau specs)
              pData.specs = pData.specs || {};
              var plcSource = (compObj.placement && typeof compObj.placement === "object") ? compObj.placement : {};
              var specsSource = (compObj.specs && typeof compObj.specs === "object") ? compObj.specs : {};

              var jLotL = compObj.lot_length || compObj.min_plot_length || compObj.lungime || compObj.lungime_parcela || compObj.dlugosc || compObj.dlugosc_dzialki || plcSource.lot_length || plcSource.min_plot_length || plcSource.length || plcSource.lungime || plcSource.dlugosc || specsSource.lot_length || specsSource.min_plot_length || specsSource.lungime_parcela || specsSource.dlugosc;
              var jLotW = compObj.lot_width || compObj.min_plot_width || compObj.latime || compObj.latime_parcela || compObj.szerokosc || compObj.szerokosc_dzialki || plcSource.lot_width || plcSource.min_plot_width || plcSource.width || plcSource.latime || plcSource.szerokosc || specsSource.lot_width || specsSource.min_plot_width || specsSource.latime_parcela || specsSource.szerokosc;
              var jElW = compObj.elevation_width || compObj.latime_fatada || compObj.szerokosc_elewacji || plcSource.elevation_width || plcSource.facade_width || plcSource.szerokosc_elewacji || specsSource.elevation_width || specsSource.latime_fatada || specsSource.szerokosc_elewacji;
              var jFp = compObj.footprint || compObj.footprint_area || compObj.amprenta || compObj.amprenta_sol || compObj.powierzchnia_zabudowy || plcSource.footprint || plcSource.footprint_area || specsSource.footprint_area || specsSource.footprint || specsSource.powierzchnia_zabudowy;

              if (jLotL && (!pData.specs.lot_length || parseFloat(pData.specs.lot_length) === 0)) {
                pData.specs.lot_length = parseFloat(jLotL);
              }
              if (jLotW && (!pData.specs.lot_width || parseFloat(pData.specs.lot_width) === 0)) {
                pData.specs.lot_width = parseFloat(jLotW);
              }
              if (jElW && (!pData.specs.elevation_width || parseFloat(pData.specs.elevation_width) === 0)) {
                pData.specs.elevation_width = parseFloat(jElW);
              }
              if (jFp && (!pData.specs.footprint_area || parseFloat(pData.specs.footprint_area) === 0)) {
                pData.specs.footprint_area = parseFloat(jFp);
              }
            }
          }

          // Fallback direct din text (puncte_forte / descriere) daca lungimea sau latimea parcelei lipsesc
          if ((!pData.specs.lot_width || parseFloat(pData.specs.lot_width) === 0 || !pData.specs.lot_length || parseFloat(pData.specs.lot_length) === 0) && mObj.puncte_forte) {
            var pfMatch = mObj.puncte_forte.match(/parcel[aă] de minim\s*(\d+[.,]?\d*)\s*m?\s*[×x*]\s*(\d+[.,]?\d*)\s*m/i);
            if (pfMatch) {
              if (!pData.specs.lot_width || parseFloat(pData.specs.lot_width) === 0) pData.specs.lot_width = parseFloat(pfMatch[1].replace(',', '.'));
              if (!pData.specs.lot_length || parseFloat(pData.specs.lot_length) === 0) pData.specs.lot_length = parseFloat(pfMatch[2].replace(',', '.'));
            }
          }

          // Fallback direct din imaginile Shopify (media_store) daca nu avem JSON complet
          if (mObj.media_store) {
            var ms = mObj.media_store;
            // 1. Daca nu exista storeys sau sunt fara imagini, le construim din plans
            if ((!pData.storeys || pData.storeys.length === 0) && ms.plans && ms.plans.length > 0) {
              pData.storeys = ms.plans.map(function(pl, i) {
                var cleanName = (pl.name_ro || "").replace(/\[.*?\]/g, "").replace(/^.*?\s*-\s*/, "").trim();
                return {
                  name_ro: cleanName || ("Plan Nivel " + (i + 1)),
                  cdn_url: pl.cdn_url,
                  usable_area: (ms.plans.length === 1 ? pData.specs.usable_area : null),
                  rooms: []
                };
              });
            } else if (pData.storeys && ms.plans && ms.plans.length > 0) {
              pData.storeys.forEach(function(st, i) {
                if (!st.cdn_url && ms.plans[i]) st.cdn_url = ms.plans[i].cdn_url;
              });
            }

            // 2. Schita teren placement
            if ((!pData.placement || (!pData.placement.cdn_url && !pData.placement.url)) && ms.placement && ms.placement.cdn_url) {
              pData.placement = pData.placement || {};
              pData.placement.cdn_url = ms.placement.cdn_url;
              pData.placement.url = ms.placement.cdn_url;
            }

            // 3. Fatade
            if ((!pData.elevations || pData.elevations.length === 0) && ms.elevations && ms.elevations.length > 0) {
              pData.elevations = ms.elevations;
            }

            // 4. Interioare
            if ((!pData.interiors || pData.interiors.length === 0) && ms.interiors && ms.interiors.length > 0) {
              pData.interiors = ms.interiors;
            }
          }
        }
      } catch(e) {
        console.warn("[z500] Metafields merge note:", e);
      }
    }

    if (pData) {
      // Normalizare robusta pentru structurile pData
      if (!pData.views && pData.images && pData.images.views) {
        pData.views = pData.images.views.map(function(v) { return typeof v === 'string' ? v : (v.cdn_url || v.url || ''); }).filter(Boolean);
      }
      if ((!pData.storeys || pData.storeys.length === 0) && pData.images && pData.images.projections) {
        pData.storeys = pData.images.projections.map(function(pr, i) {
          return {
            name_ro: "Plan Nivel " + (i + 1),
            cdn_url: typeof pr === 'string' ? pr : (pr.cdn_url || pr.url || ''),
            rooms: []
          };
        });
      }

      // 4. Fallback Vederi 3D Hero daca product.images nu e inca complet sincronizat in Shopify
      var activeViews = (window.zImagesList && window.zImagesList.length > 0) ? window.zImagesList : (pData.views || []);
      if ((!window.zImagesList || window.zImagesList.length === 0) && activeViews.length > 0) {
        window.zImagesList = activeViews;
        var mainEl = document.getElementById("zHeroMain");
        if (mainEl && activeViews[0]) mainEl.src = activeViews[0];

        var side1El = document.getElementById("zHeroSide1");
        var sideSlide1 = document.getElementById("zSideSlide1");
        if (side1El && activeViews.length > 1) {
          side1El.src = activeViews[1];
          if (sideSlide1) sideSlide1.style.display = "block";
        }

        var side2El = document.getElementById("zHeroSide2");
        var sideSlide2 = document.getElementById("zSideSlide2");
        if (side2El && activeViews.length > 2) {
          side2El.src = activeViews[2];
          if (sideSlide2) sideSlide2.style.display = "block";
        }

        var track = document.getElementById("zThumbTrack");
        if (track && track.children.length === 0) {
          activeViews.forEach(function(vUrl, vIdx) {
            var item = document.createElement("div");
            item.className = "z-thumb-item" + (vIdx === 0 ? " active" : "");
            item.onclick = function() { zSelectSlide(vIdx); };
            item.innerHTML = '<img src="' + vUrl + '" alt="Randare 3D ' + (vIdx + 1) + '" />';
            track.appendChild(item);
          });
        }
      }
    }

    if (pData && dynContainer) {
        var html = "";

        // 1. BENTO GRID: SPECIFICATII ARHITECTURALE CHEIE & EFICIENTA nZEB
        if (pData.specs) {
          var s = pData.specs;
          var sLotW = s.lot_width || s.min_plot_width || (pData.placement && (pData.placement.lot_width || pData.placement.min_plot_width)) || pData.lot_width;
          var sLotL = s.lot_length || s.min_plot_length || (pData.placement && (pData.placement.lot_length || pData.placement.min_plot_length)) || pData.lot_length;
          var sMinPlotArea = (sLotW && sLotL) ? (parseFloat(sLotW) * parseFloat(sLotL)).toFixed(0) : null;

          html += '<div class="z-section-block z-bento-section">';
          html += '  <div class="z-sec-header-row">';
          html += '    <div>';
          html += '      <span class="z-sec-eyebrow">Matrice Tehnică & Standarde</span>';
          html += '      <h2 class="z-sec-heading">Parametri Tehnici & Confort nZEB</h2>';
          html += '    </div>';
          html += '    <div class="z-badge-standard" style="padding:6px 14px; font-size:12px;">Conformitate nZEB 2026</div>';
          html += '  </div>';

          html += '  <div class="z-bento-grid">';
          
          // Card 1: Suprafata Utila (Hero Metric)
          if (s.usable_area) {
            html += '    <div class="z-bento-card z-bento-card--hero">';
            html += '      <div class="z-bento-top">';
            html += '        <div class="z-bento-icon-box"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 3h18v18H3z"></path><path d="M3 9h18"></path><path d="M9 21V9"></path></svg></div>';
            html += '        <div class="z-bento-label">Suprafață Utilă Totală</div>';
            html += '      </div>';
            html += '      <div class="z-bento-value">' + s.usable_area + ' <span class="z-bento-unit">m²</span></div>';
            if (s.net_area && s.net_area !== s.usable_area) {
              html += '      <div class="z-bento-sub">Calculată la cota finită &bull; Suprafață netă totală: ' + s.net_area + ' m²</div>';
            } else {
              html += '      <div class="z-bento-sub">Calculată la cota finită a pardoselilor interioare</div>';
            }
            html += '    </div>';
          }

          // Card 2: Amprenta la Sol
          if (s.footprint_area) {
            html += '    <div class="z-bento-card">';
            html += '      <div class="z-bento-top">';
            html += '        <div class="z-bento-icon-box"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline></svg></div>';
            html += '        <div class="z-bento-label">Amprentă la Sol (P.O.T.)</div>';
            html += '      </div>';
            html += '      <div class="z-bento-value">' + s.footprint_area + ' <span class="z-bento-unit">m²</span></div>';
            html += '      <div class="z-bento-sub">Suprafață construită la nivelul cotei &plusmn;0.00</div>';
            html += '    </div>';
          }

          // Card 3: Minim Teren Recomandat
          if (sLotW && sLotL) {
            html += '    <div class="z-bento-card z-bento-card--accent">';
            html += '      <div class="z-bento-top">';
            html += '        <div class="z-bento-icon-box"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon></svg></div>';
            html += '        <div class="z-bento-label">Dimensiuni Minime Parcelă</div>';
            html += '      </div>';
            html += '      <div class="z-bento-value">' + sLotW + ' &times; ' + sLotL + ' <span class="z-bento-unit">m</span></div>';
            html += '      <div class="z-bento-sub">Parcelă optimă: min. ' + (sMinPlotArea ? sMinPlotArea + ' m²' : 'conform retrageri') + '</div>';
            html += '    </div>';
          }

          // Card 4: Camere & Compartimentare
          if (s.rooms_count) {
            html += '    <div class="z-bento-card">';
            html += '      <div class="z-bento-top">';
            html += '        <div class="z-bento-icon-box"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg></div>';
            html += '        <div class="z-bento-label">Număr Camere</div>';
            html += '      </div>';
            html += '      <div class="z-bento-value">' + s.rooms_count + ' <span class="z-bento-unit">camere</span></div>';
            html += '      <div class="z-bento-sub">Living generos + 3 dormitoare optimizate termic</div>';
            html += '    </div>';
          }

          // Card 5: Inaltime & Acoperis
          if (s.height || s.roof_angle) {
            html += '    <div class="z-bento-card">';
            html += '      <div class="z-bento-top">';
            html += '        <div class="z-bento-icon-box"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 11l9-8 9 8M5 10v10h14V10"></path></svg></div>';
            html += '        <div class="z-bento-label">Volumetrie & Șarpantă</div>';
            html += '      </div>';
            var hStr = s.height ? (s.height + ' m înălțime') : '';
            var rStr = s.roof_angle ? (s.roof_angle + '° înclinare') : '';
            var comb = [hStr, rStr].filter(Boolean).join(' • ');
            html += '      <div class="z-bento-value" style="font-size:22px;">' + (comb || 'Pante optime') + '</div>';
            html += '      <div class="z-bento-sub">Orientare ideală pentru panouri fotovoltaice</div>';
            html += '    </div>';
          }

          // Card 6: Eficienta Energetica
          html += '    <div class="z-bento-card z-bento-card--eco">';
          html += '      <div class="z-bento-top">';
          html += '        <div class="z-bento-icon-box"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2v8M12 18v4M4.93 4.93l5.66 5.66M18.36 18.36l-5.66-5.66M2 12h8M18 12h4M4.93 19.07l5.66-5.66M18.36 5.64l-5.66 5.66"></path></svg></div>';
          html += '        <div class="z-bento-label">Standard Energetic</div>';
          html += '      </div>';
          html += '      <div class="z-bento-value" style="font-size:22px; color:#166534;">nZEB Eficient</div>';
          html += '      <div class="z-bento-sub">Anvelopă fără punți termice, compatibil pompă căldură</div>';
          html += '    </div>';

          html += '  </div>';
          html += '</div>';
        }

        // 2. PLANURI PE NIVELURI CU COMUTATOR SI LISTA DE INCAPERI (ANTI-TRUNCATION FLEXIBLE GRID)
        if (pData.storeys && pData.storeys.length > 0) {
          window.zPlanGallery = pData.storeys.map(function(st) {
            return st.plan_image || st.cdn_url || st.image_url || "https://cdn.shopify.com/s/files/1/1076/8272/6213/files/projekt-domu-z241-d-z500-rzut-2374_55f8b2a1-7a85-4abd-8d8a-6f30899f02a8.svg?v=1790668125";
          }).filter(Boolean);
          window.zPlanCaptions = pData.storeys.map(function(st, i) {
            return "Plan " + (st.name || st.name_ro || ("Nivel " + (i + 1)));
          });

          html += '<div class="z-section-block">';
          html += '  <div class="z-sec-header-row">';
          html += '    <div>';
          html += '      <span class="z-sec-eyebrow">Concepție Arhitecturală</span>';
          html += '      <h2 class="z-sec-heading">Planurile Construcției pe Niveluri</h2>';
          html += '    </div>';
          if (pData.storeys.length > 1) {
            html += '    <div class="z-floor-switch">';
            pData.storeys.forEach(function(st, idx) {
              var activeClass = idx === 0 ? "active" : "";
              var stName = st.name || st.name_ro || ("Nivel " + (idx+1));
              html += '      <button type="button" class="z-floor-btn ' + activeClass + '" data-storey-idx="' + idx + '">' + stName + '</button>';
            });
            html += '    </div>';
          }
          html += '  </div>';

          // Panouri pentru fiecare nivel
          pData.storeys.forEach(function(st, idx) {
            var activeClass = idx === 0 ? " active" : "";
            var planImg = st.plan_image || st.cdn_url || st.image_url || "https://cdn.shopify.com/s/files/1/1076/8272/6213/files/projekt-domu-z241-d-z500-rzut-2374_55f8b2a1-7a85-4abd-8d8a-6f30899f02a8.svg?v=1790668125";
            var stName = st.name || st.name_ro || ("Nivel " + (idx + 1));

            html += '  <div class="z-plan-display' + activeClass + '" id="zStoreyPanel_' + idx + '">';
            html += '    <div class="z-plan-frame z-lightbox-trigger" data-lbox-group="plan" data-lbox-idx="' + idx + '" data-lbox-url="' + encodeURI(planImg) + '" data-lbox-cap="Plan ' + encodeURIComponent(stName) + '" style="cursor:zoom-in;" onclick="zOpenLboxGallery(window.zPlanGallery, window.zPlanCaptions, ' + idx + '); event.stopPropagation();">';
            html += '      <img src="' + planImg + '" alt="Plan ' + stName + '" loading="lazy" onerror="this.onerror=null; this.src=\'https://cdn.shopify.com/s/files/1/1076/8272/6213/files/projekt-domu-z241-d-z500-rzut-2374_55f8b2a1-7a85-4abd-8d8a-6f30899f02a8.svg?v=1790668125\';" />';
            html += '      <div class="z-zoom-hint">Click pentru mărire ecran complet</div>';
            html += '    </div>';

            var stRooms = st.rooms;
            if (typeof stRooms === "string") {
              try { stRooms = JSON.parse(stRooms); } catch(e) { stRooms = []; }
            }
            if ((!stRooms || stRooms.length === 0) && pData.rooms_by_storey) {
              var lvlKey = String(st.level || (idx + 1));
              var rbs = pData.rooms_by_storey[lvlKey] || pData.rooms_by_storey[idx] || pData.rooms_by_storey[idx+1];
              if (rbs && rbs.rooms && rbs.rooms.length > 0) {
                stRooms = rbs.rooms;
              }
            }

            var stUsable = st.usable_area;
            if (!stUsable && stRooms && stRooms.length > 0) {
              var aSum = 0;
              stRooms.forEach(function(r) {
                var val = parseFloat(r.area || r.usable_area || r.usable || 0);
                if (!isNaN(val)) aSum += val;
              });
              if (aSum > 0) stUsable = aSum.toFixed(2);
            }

            html += '    <div class="z-rooms-panel">';
            html += '      <h3 style="margin-top:0; font-size:18px; color:var(--z-text, #2a2520); font-family:var(--arhi-font-display, inherit); font-weight:700;">Compartimentare ' + stName + (stUsable ? ' (' + stUsable + ' m²)' : '') + '</h3>';
            if (stRooms && stRooms.length > 0) {
              html += '      <div class="z-rooms-list">';
              stRooms.forEach(function(r) {
                var rNo = (r.no !== undefined && r.no !== null && r.no !== '') ? r.no : (r.room_no || '');
                var rName = r.name_ro || r.name || 'Încăpere';
                var rArea = '';
                var rUsableRaw = r.usable_area !== undefined ? r.usable_area : (r.usable !== undefined ? r.usable : NaN);
                var rNetRaw = r.net_area !== undefined ? r.net_area : (r.net !== undefined ? r.net : NaN);
                var rUsable = parseFloat(rUsableRaw);
                var rNet = parseFloat(rNetRaw);
                if (!isNaN(rUsable) && !isNaN(rNet) && Math.abs(rUsable - rNet) > 0.01) {
                  rArea = rUsable.toFixed(2) + ' m² / ' + rNet.toFixed(2) + ' m²';
                } else if (r.area_str) {
                  rArea = r.area_str;
                } else if (!isNaN(rUsable)) {
                  rArea = rUsable.toFixed(2) + ' m²';
                } else if (!isNaN(rNet)) {
                  rArea = rNet.toFixed(2) + ' m²';
                } else if (r.area !== undefined && r.area !== null && r.area !== '') {
                  rArea = r.area + (String(r.area).indexOf('m²') === -1 ? ' m²' : '');
                }
                html += '        <div class="z-room-row">';
                html += '          <div class="z-room-left">';
                html += '            <span class="z-room-badge">' + rNo + '</span>';
                html += '            <span class="z-room-title">' + rName + '</span>';
                html += '          </div>';
                html += '          <div class="z-room-area">' + rArea + '</div>';
                html += '        </div>';
              });
              html += '      </div>';
            } else {
              html += '      <div style="background:#f8fafc; border:1px solid #e2e8f0; border-radius:12px; padding:18px; color:#475569; font-size:14px; line-height:1.6;">';
              html += '        <p style="margin:0 0 8px 0; font-weight:700; color:#0f172a;">Compartimentare Nivel ' + stName + ':</p>';
              html += '        <p style="margin:0;">Suprafață utilă nivel: <strong>' + (st.usable_area || (pData.specs && pData.specs.usable_area) || '-') + ' m²</strong>.</p>';
              html += '        <p style="margin:6px 0 0 0; font-size:13px; color:#64748b;">Planurile detaliate cotate și specificațiile fiecărei încăperi sunt incluse în dosarul tehnic complet (D.T.A.C. + P.T.H.).</p>';
              html += '      </div>';
            }
            html += '    </div>';
            html += '  </div>';
          });

          html += '</div>';
        }

        // 3. AMPLASARE PE PARCELA (TEREN) & RETRAGERI URBANISTICE
        var plcImg = pData.placement_image || (pData.placement ? (pData.placement.cdn_url || pData.placement.url || (typeof pData.placement === "string" ? pData.placement : "")) : "");
        if (!plcImg) {
          plcImg = "https://cdn.shopify.com/s/files/1/1076/8272/6213/files/projekt-domu-z241-d-z500-plan-dzialki-2375_7a04d555-d6ba-4523-b774-6f4ca78adb13.svg?v=1790668125";
        }
        var sp = pData.specs || {};
        var plcObj = (pData.placement && typeof pData.placement === "object") ? pData.placement : {};
        var lotW = sp.lot_width || sp.min_plot_width || plcObj.lot_width || plcObj.min_plot_width || plcObj.width || (pData.lot_width || 17.8);
        var lotL = sp.lot_length || sp.min_plot_length || plcObj.lot_length || plcObj.min_plot_length || plcObj.length || (pData.lot_length || 21.4);
        var elW = sp.elevation_width || plcObj.elevation_width || plcObj.facade_width || (pData.elevation_width || 10.8);
        var fp = sp.footprint_area || sp.footprint || plcObj.footprint_area || plcObj.footprint || (pData.footprint || 128.5);

        if (plcImg || (lotW && lotL) || elW) {
          html += '<div class="z-section-block">';
          html += '  <div class="z-sec-header-row">';
          html += '    <div>';
          html += '      <span class="z-sec-eyebrow">Urbanism & Sit</span>';
          html += '      <h2 class="z-sec-heading">Amplasare pe Teren & Dimensiuni Minime Parcelă</h2>';
          html += '    </div>';
          html += '  </div>';
          html += '  <div class="z-plot-grid">';
          if (plcImg) {
            html += '    <div class="z-plan-frame z-lightbox-trigger" data-lbox-url="' + encodeURI(plcImg) + '" data-lbox-cap="Amplasare pe parcelă" style="cursor:zoom-in;" onclick="zOpenLboxGallery([\''+plcImg+'\'], [\'Amplasare pe parcelă\'], 0); event.stopPropagation();">';
            html += '      <img src="' + plcImg + '" alt="Amplasare teren" loading="lazy" onerror="this.onerror=null; this.src=\'https://cdn.shopify.com/s/files/1/1076/8272/6213/files/projekt-domu-z241-d-z500-plan-dzialki-2375_7a04d555-d6ba-4523-b774-6f4ca78adb13.svg?v=1790668125\';" />';
            html += '      <div class="z-zoom-hint">Click pentru mărire schiță teren</div>';
            html += '    </div>';
          }
          html += '    <div class="z-plot-specs-box">';
          html += '      <h3 style="margin: 0 0 16px 0; font-size: 18px; color: var(--z-text, #2a2520); font-weight: 700; font-family:var(--arhi-font-display, inherit);">Ghid Încadrare Parcela:</h3>';
          if (lotW) {
            html += '      <div class="z-plot-spec-item"><span class="z-plot-lbl">Lățime minimă parcelă:</span><span class="z-plot-val">' + lotW + ' m</span></div>';
          }
          if (lotL) {
            html += '      <div class="z-plot-spec-item"><span class="z-plot-lbl">Lungime minimă parcelă:</span><span class="z-plot-val">' + lotL + ' m</span></div>';
          }
          if (elW) {
            html += '      <div class="z-plot-spec-item"><span class="z-plot-lbl">Lățime fațadă (imobil):</span><span class="z-plot-val">' + elW + ' m</span></div>';
          }
          if (lotW && lotL) {
            var minPlotArea = (parseFloat(lotW) * parseFloat(lotL)).toFixed(0);
            html += '      <div class="z-plot-spec-item"><span class="z-plot-lbl">Suprafață minimă teren recomandată:</span><span class="z-plot-val">' + minPlotArea + ' m²</span></div>';
          } else if (fp) {
            html += '      <div class="z-plot-spec-item"><span class="z-plot-lbl">Suprafață construită la sol (amprentă):</span><span class="z-plot-val">' + fp + ' m²</span></div>';
          }
          html += '      <div style="margin-top:18px; padding-top:14px; border-top:1px solid #e2e8f0; font-size:13px; color:var(--z-text-muted, #64748b); line-height:1.5;">';
          html += '        Dimensiunile includ retragerile regulamentare față de limitele de proprietate (Cod Civil / PUG). Pentru terenuri în pantă sau înguste, oferim adaptare de specialitate.';
          html += '      </div>';
          html += '    </div>';
          html += '  </div>';
          html += '</div>';
        }

        // 4. SUPRAFETE & DIMENSIUNI COMPLETE (TABEL ARHITECTURAL)
        if (pData.specs) {
          var sp = pData.specs;
          html += '<div class="z-section-block">';
          html += '  <div class="z-sec-header-row">';
          html += '    <div>';
          html += '      <span class="z-sec-eyebrow">Fișă de Proiect</span>';
          html += '      <h2 class="z-sec-heading">Suprafețe & Dimensiuni Complete</h2>';
          html += '    </div>';
          html += '  </div>';
          html += '  <table class="z-specs-table"><tbody>';
          if (sp.usable_area) {
            html += '    <tr><td>Suprafață utilă:</td><td><strong>' + sp.usable_area + ' m²</strong></td></tr>';
          }
          if (sp.net_area) {
            html += '    <tr><td>Suprafață netă totală:</td><td>' + sp.net_area + ' m²</td></tr>';
          }
          if (sp.footprint_area) {
            html += '    <tr><td>Suprafață construită la sol (amprentă):</td><td>' + sp.footprint_area + ' m²</td></tr>';
          }
          if (sp.garage_area && sp.garage_area > 0) {
            html += '    <tr><td>Suprafață garaj:</td><td>' + sp.garage_area + ' m²</td></tr>';
          }
          if (sp.lot_width && sp.lot_length) {
            html += '    <tr><td>Dimensiuni minime teren (parcelă):</td><td><strong>' + sp.lot_width + ' × ' + sp.lot_length + ' m</strong></td></tr>';
          }
          if (sp.elevation_width) {
            html += '    <tr><td>Lățime fațadă (imobil):</td><td>' + sp.elevation_width + ' m</td></tr>';
          }
          if (sp.height) {
            html += '    <tr><td>Înălțime coamă acoperiș:</td><td>' + sp.height + ' m</td></tr>';
          }
          if (sp.roof_angle) {
            html += '    <tr><td>Unghi înclinație acoperiș:</td><td>' + sp.roof_angle + '°</td></tr>';
          }
          if (sp.cubature) {
            html += '    <tr><td>Volum interior (cubatură):</td><td>' + sp.cubature + ' m³</td></tr>';
          }
          html += '    <tr><td>Documentație inclusă:</td><td>D.T.A.C. + P.T.H. (Arhitectură, Rezistență, Instalații)</td></tr>';
          html += '  </tbody></table>';
          html += '</div>';
        }

        // 5. MODUL DINAMIC: PERSPECTIVE ARHITECTURALE & VEDERI TEHNICE (STRICT CONDITiONAT)
        var hasElev = pData.elevations && pData.elevations.length > 0;
        var hasInter = pData.interiors && pData.interiors.length > 0;

        if (hasElev) {
          window.zElevationGallery = pData.elevations.map(function(el) {
            return el.image || el.cdn_url || el.url;
          }).filter(Boolean);
          window.zElevationCaptions = pData.elevations.map(function(el, idx) {
            return el.name || ("Fațadă " + (idx + 1) + " din " + pData.elevations.length);
          });
        }
        if (hasInter) {
          window.zInteriorGallery = pData.interiors.map(function(it) {
            return it.full_url || it.image || it.cdn_url || it.url;
          }).filter(Boolean);
          window.zInteriorCaptions = pData.interiors.map(function(it, idx) {
            return it.name || ("Randare Interioară " + (idx + 1) + " din " + pData.interiors.length);
          });
        }

        if (hasElev && hasInter) {
          html += '<div class="z-section-block">';
          html += '  <div class="z-sec-header-row">';
          html += '    <div>';
          html += '      <span class="z-sec-eyebrow">Vederi Arhitecturale</span>';
          html += '      <h2 class="z-sec-heading">Perspective Arhitecturale & Vederi Tehnice</h2>';
          html += '    </div>';
          html += '    <div class="z-perspectives-tabs">';
          html += '      <button type="button" class="z-persp-tab-btn active" data-persp-target="elevations">Fațade Tehnice (' + pData.elevations.length + ')</button>';
          html += '      <button type="button" class="z-persp-tab-btn" data-persp-target="interiors">Amenajare Interioară (' + pData.interiors.length + ')</button>';
          html += '    </div>';
          html += '  </div>';

          html += '  <div class="z-persp-panel" id="zPerspElevations" style="display:block;">';
          html += '    <div class="z-elevations-grid">';
          pData.elevations.forEach(function(el, elIdx) {
            var elImg = el.image || el.cdn_url || el.url;
            var elZoomImg = el.full_url || elImg;
            var elName = el.name || ("Fațadă " + (elIdx + 1));
            html += '      <div class="z-card z-lightbox-trigger" data-lbox-group="elevation" data-lbox-idx="' + elIdx + '" data-lbox-url="' + encodeURI(elZoomImg) + '" data-lbox-cap="' + encodeURIComponent(elName) + '" onclick="zOpenLboxGallery(window.zElevationGallery, window.zElevationCaptions, ' + elIdx + '); event.stopPropagation();">';
            html += '        <img src="' + elImg + '" alt="' + elName + '" loading="lazy" decoding="async" onerror="this.onerror=null; this.src=\'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=600&q=80\';" />';
            html += '        <div class="z-card-cap"><span>' + elName + '</span><span class="z-card-zoom-tag">Zoom</span></div>';
            html += '      </div>';
          });
          html += '    </div>';
          html += '  </div>';

          html += '  <div class="z-persp-panel" id="zPerspInteriors" style="display:none;">';
          html += '    <div class="z-cards-grid">';
          pData.interiors.forEach(function(it, itIdx) {
            var itImg = it.image || it.cdn_url || it.url;
            var itZoomImg = it.full_url || itImg;
            var itName = it.name || ("Randare Interioară " + (itIdx + 1));
            html += '      <div class="z-card is-interior z-lightbox-trigger" data-lbox-group="interior" data-lbox-idx="' + itIdx + '" data-lbox-url="' + encodeURI(itZoomImg) + '" data-lbox-cap="' + encodeURIComponent(itName) + '" onclick="zOpenLboxGallery(window.zInteriorGallery, window.zInteriorCaptions, ' + itIdx + '); event.stopPropagation();">';
            html += '        <img src="' + itImg + '" alt="' + itName + '" loading="lazy" decoding="async" onerror="this.onerror=null; this.src=\'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=600&q=80\';" />';
            html += '        <div class="z-card-cap"><span>' + itName + '</span><span class="z-card-zoom-tag">Zoom</span></div>';
            html += '      </div>';
          });
          html += '    </div>';
          html += '  </div>';
          html += '</div>';

        } else if (hasElev) {
          html += '<div class="z-section-block">';
          html += '  <div class="z-sec-header-row">';
          html += '    <div>';
          html += '      <span class="z-sec-eyebrow">Elevanții CAD</span>';
          html += '      <h2 class="z-sec-heading">Fațade & Elevanții Tehnice (' + pData.elevations.length + ' vederi)</h2>';
          html += '    </div>';
          html += '  </div>';
          html += '  <div class="z-elevations-grid">';
          pData.elevations.forEach(function(el, elIdx) {
            var elImg = el.image || el.cdn_url || el.url;
            var elZoomImg = el.full_url || elImg;
            var elName = el.name || ("Fațadă " + (elIdx + 1));
            html += '    <div class="z-card z-lightbox-trigger" data-lbox-group="elevation" data-lbox-idx="' + elIdx + '" data-lbox-url="' + encodeURI(elZoomImg) + '" data-lbox-cap="' + encodeURIComponent(elName) + '" onclick="zOpenLboxGallery(window.zElevationGallery, window.zElevationCaptions, ' + elIdx + '); event.stopPropagation();">';
            html += '      <img src="' + elImg + '" alt="' + elName + '" loading="lazy" decoding="async" onerror="this.onerror=null; this.src=\'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=600&q=80\';" />';
            html += '      <div class="z-card-cap"><span>' + elName + '</span><span class="z-card-zoom-tag">Zoom</span></div>';
            html += '    </div>';
          });
          html += '  </div>';
          html += '</div>';
        }

        // 6. DEVIZ ESTIMATIV COSTURI CONSTRUCTIE - ROADMAP VIZUAL INTERACTIV
        var uBase = (pData.specs && pData.specs.usable_area) ? pData.specs.usable_area : 102.4;
        var _d = 1.45;
        var cCota0 = Math.round(uBase * 160 / _d);
        var cRosu = Math.round(uBase * 580 / _d);
        var cGri = Math.round(uBase * 940 / _d);
        var cInst = Math.round(uBase * 140 / _d);
        var cFin = Math.round(uBase * 420 / _d);
        var cTot = Math.round(uBase * 1500 / _d);

        html += '<div class="z-section-block z-cost-section">';
        html += '  <div class="z-sec-header-row">';
        html += '    <div>';
        html += '      <span class="z-sec-eyebrow">Predictibilitate Buget</span>';
        html += '      <h2 class="z-sec-heading">Deviz Estimativ Costuri Construcție (Orientativ 2026)</h2>';
        html += '    </div>';
        html += '    <div class="z-cost-total-badge">';
        html += '      <span class="z-cost-total-lbl">Investiție Totală Estimat La Cheie:</span>';
        html += '      <strong class="z-cost-total-val">~ ' + cTot.toLocaleString("ro-RO") + ' €</strong>';
        html += '    </div>';
        html += '  </div>';

        // Segmented Visual Bar
        html += '  <div class="z-cost-bar-container" title="Ponderea costurilor pe etape">';
        html += '    <div class="z-cost-segment z-cost-seg-1" style="width: 11%;" title="Fundație ~11%"></div>';
        html += '    <div class="z-cost-segment z-cost-seg-2" style="width: 38%;" title="La Roșu ~38%"></div>';
        html += '    <div class="z-cost-segment z-cost-seg-3" style="width: 23%;" title="La Gri ~23%"></div>';
        html += '    <div class="z-cost-segment z-cost-seg-4" style="width: 9%;" title="Instalații ~9%"></div>';
        html += '    <div class="z-cost-segment z-cost-seg-5" style="width: 19%;" title="Finisaje ~19%"></div>';
        html += '  </div>';

        // Milestone Cards Grid
        html += '  <div class="z-cost-cards-grid">';
        html += '    <div class="z-cost-card">';
        html += '      <span class="z-cost-stage">Etapa 1 &bull; Cota 0</span>';
        html += '      <h4 class="z-cost-name">Infrastructură &amp; Fundație</h4>';
        html += '      <p class="z-cost-desc">Săpături, hidroizolație, armătură și turnare placă cotă zero</p>';
        html += '      <div class="z-cost-amount">~ ' + cCota0.toLocaleString("ro-RO") + ' €</div>';
        html += '    </div>';

        html += '    <div class="z-cost-card">';
        html += '      <span class="z-cost-stage">Etapa 2 &bull; Structură</span>';
        html += '      <h4 class="z-cost-name">Construcție la Roșu</h4>';
        html += '      <p class="z-cost-desc">Zidărie portantă, stâlpi beton armat, planșeu, șarpantă și învelitoare</p>';
        html += '      <div class="z-cost-amount">~ ' + cRosu.toLocaleString("ro-RO") + ' €</div>';
        html += '    </div>';

        html += '    <div class="z-cost-card">';
        html += '      <span class="z-cost-stage">Etapa 3 &bull; Închidere</span>';
        html += '      <h4 class="z-cost-name">Semifinisat / La Gri</h4>';
        html += '      <p class="z-cost-desc">Tâmplărie tripan termoizolantă, termosistem fațadă, tencuieli, șape</p>';
        html += '      <div class="z-cost-amount">~ ' + cGri.toLocaleString("ro-RO") + ' €</div>';
        html += '    </div>';

        html += '    <div class="z-cost-card">';
        html += '      <span class="z-cost-stage">Etapa 4 &bull; Rețele</span>';
        html += '      <h4 class="z-cost-name">Instalații Complete</h4>';
        html += '      <p class="z-cost-desc">Rețea electrică, încălzire în pardoseală, trasee sanitare & ventilație</p>';
        html += '      <div class="z-cost-amount">~ ' + cInst.toLocaleString("ro-RO") + ' €</div>';
        html += '    </div>';

        html += '    <div class="z-cost-card">';
        html += '      <span class="z-cost-stage">Etapa 5 &bull; Recepție</span>';
        html += '      <h4 class="z-cost-name">Finisaje &amp; La Cheie</h4>';
        html += '      <p class="z-cost-desc">Placări ceramice, parchet, zugrăveli, uși, aparataje &ndash; gata de locuit</p>';
        html += '      <div class="z-cost-amount">~ ' + cFin.toLocaleString("ro-RO") + ' €</div>';
        html += '    </div>';
        html += '  </div>';

        html += '  <p style="margin:16px 0 0 0; font-size:13px; color:var(--z-text-muted, #736d65); line-height:1.5;">*Estimările reflectă mediile indicilor de deviz național conform normativelor europene. Proiectul complet D.T.A.C. + P.T.H. include antemăsurători exacte pentru ofertare transparentă la constructori.</p>';
        html += '</div>';

        dynContainer.innerHTML = html;

        // Ascundem blocurile tehnice duplicate din descrierea editoriala
        var editEl = document.querySelector(".z-editorial-body");
        if (editEl) {
          editEl.querySelectorAll(".z-section-card").forEach(function(card) {
            card.style.display = "none";
          });
        }
      }
    }

    window.initZ500Dynamic = initZ500Dynamic;

    // Siguranta la executie si delegare de evenimente pentru zoom si etaje
    function safeInit() {
      try {
        initZ500Dynamic();
      } catch(err) {
        console.error("[Z500] Error initializing dynamic content:", err);
      }
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", safeInit);
    } else {
      safeInit();
    }
    window.addEventListener("load", safeInit);
    document.addEventListener("shopify:section:load", safeInit);
    setTimeout(safeInit, 200);
    setTimeout(safeInit, 800);

    document.addEventListener("click", function(e) {
      // 1. Delegare comutator etaje
      var floorBtn = e.target.closest(".z-floor-btn");
      if (floorBtn) {
        var idx = parseInt(floorBtn.getAttribute("data-storey-idx"), 10);
        document.querySelectorAll("[id^='zStoreyPanel_']").forEach(function(p, i) {
          if (i === idx) {
            p.classList.add("active");
            p.style.display = "";
          } else {
            p.classList.remove("active");
            p.style.display = "none";
          }
        });
        document.querySelectorAll(".z-floor-btn").forEach(function(b) {
          b.classList.remove("active");
        });
        floorBtn.classList.add("active");
        return;
      }

      // 2. Delegare comutator perspective (fatade vs interioare)
      var perspBtn = e.target.closest(".z-persp-tab-btn");
      if (perspBtn) {
        var target = perspBtn.getAttribute("data-persp-target");
        var elevPanel = document.getElementById("zPerspElevations");
        var interPanel = document.getElementById("zPerspInteriors");
        if (elevPanel && interPanel) {
          if (target === "elevations") {
            elevPanel.style.display = "block";
            interPanel.style.display = "none";
          } else {
            elevPanel.style.display = "none";
            interPanel.style.display = "block";
          }
        }
        document.querySelectorAll(".z-persp-tab-btn").forEach(function(b) {
          b.classList.remove("active");
        });
        perspBtn.classList.add("active");
        return;
      }

      // 3. Delegare zoom lightbox
      var trigger = e.target.closest(".z-lightbox-trigger");
      if (trigger) {
        var group = trigger.getAttribute("data-lbox-group");
        var idx = parseInt(trigger.getAttribute("data-lbox-idx"), 10);
        if (group === "interior" && window.zInteriorGallery && window.zInteriorGallery.length > 0) {
          zOpenLboxGallery(window.zInteriorGallery, window.zInteriorCaptions, isNaN(idx) ? 0 : idx);
          return;
        }
        if (group === "elevation" && window.zElevationGallery && window.zElevationGallery.length > 0) {
          zOpenLboxGallery(window.zElevationGallery, window.zElevationCaptions, isNaN(idx) ? 0 : idx);
          return;
        }
        if (group === "plan" && window.zPlanGallery && window.zPlanGallery.length > 0) {
          zOpenLboxGallery(window.zPlanGallery, window.zPlanCaptions, isNaN(idx) ? 0 : idx);
          return;
        }
        var u = trigger.getAttribute("data-lbox-url");
        var cap = decodeURIComponent(trigger.getAttribute("data-lbox-cap") || "");
        if (u) {
          zOpenLboxUrl(decodeURI(u), cap);
        }
      }
    });

    // 4. Sticky Contextual Bar Scroll Observer & Footer Collision Guard
    function initStickyBarObserver() {
      var bar = document.getElementById("zStickyBar");
      var hero = document.querySelector(".z-header-bar");
      var footer = document.querySelector("footer") || document.querySelector(".arhi-footer-wrapper");
      if (!bar) return;

      var heroPassed = false;
      var footerReached = false;

      function updateStickyState() {
        if (heroPassed && !footerReached) {
          bar.classList.add("is-visible");
        } else {
          bar.classList.remove("is-visible");
        }
      }

      if ("IntersectionObserver" in window) {
        if (hero) {
          var heroObs = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
              heroPassed = !entry.isIntersecting && (entry.boundingClientRect.top < 0);
              updateStickyState();
            });
          }, { threshold: 0.05 });
          heroObs.observe(hero);
        }

        if (footer) {
          var footObs = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
              footerReached = entry.isIntersecting;
              updateStickyState();
            });
          }, { threshold: 0.05, rootMargin: "0px 0px 80px 0px" });
          footObs.observe(footer);
        }
      }
    }
    setTimeout(initStickyBarObserver, 500);

    // Teleport lightbox modal to document.body to escape any section stacking context
    var lbox = document.getElementById("zLightboxModal");
    if (lbox && lbox.parentElement !== document.body) {
      document.body.appendChild(lbox);
    }
  
  })();